
export const EXECUTING = 'executing';
export const COMPLETE = 'complete';
export const ERROR = 'error';
export const SET_CURRENT_USER  = 'setCurrentUser';
export const LOGOUT = 'logout';
export const LOGIN = 'login';
export const SET_PROVIDERS = 'setProviders';
export const SET_REPORTS = 'setReports';
export const SET_REPORT_DETAILS = 'setReportDetails';
export const SET_DIALOG_STATE = 'setDialogState';
export const SET_BUILD_VERSION = 'setBuildVersion';
export const SET_VERIFICATION  = 'setVolunteerVerification';
export const SET_VERIFICATIONS  = 'setVerifications';
export const SET_POSTBACK_ERROR_LOGS  = 'setPostbackErrorLogs';
export const SET_POSTBACK_ERROR_LOG  = 'setPostbackErrorLog';
export const SET_USERS = 'setUsers';
export const SET_USER = 'setUser';
export const COOKIE = 'gumshoe_client';

